module.exports = __webpack_public_path__ + "img/_0008_图层-10.0e81b28a.png";